import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditRoleComponent } from './edit-role.component';
import { EditRoleRoutingModule } from './edit-role-routing.module';
import { RoleFormModule } from '../form/role-form.module';
import { SharedModule } from '../../../../shared/shared.module';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    EditRoleRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    RoleFormModule,
  ],
  declarations: [EditRoleComponent],
  exports: [EditRoleComponent],
  providers: [],
})
export class EditRoleModule {}
